var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-container"},[_vm._t("slot-dynamic-list-item"),_vm._v(" "),(_vm.show_add)?_c('div',{staticClass:"add-item-list",on:{"click":_vm.addInstance}},[_vm._v(" "+_vm._s(_vm.add_title))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }